import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function BlogPost() {
  const { slug } = useParams()
  const [post, setPost] = useState(undefined)
  useEffect(() => {
    setPost(undefined)
    fetch(`/admin/api/public/posts/${encodeURIComponent(slug)}`).then(r => r.ok ? r.json() : null).then(setPost).catch(() => setPost(null))
  }, [slug])
  if (post === undefined) return <div className="py-16 text-center text-muted-foreground">Loading article…</div>
  if (!post) return <Navigate to="/404" replace />
  return <article id="main-content" className="prose prose-sm sm:prose-base dark:prose-invert max-w-4xl mx-auto px-4 py-12">
    <Helmet>
      <title>{post.seoTitle || post.title}</title>
      <meta name="description" content={post.metaDescription || post.excerpt} />
      {post.canonical && <link rel="canonical" href={post.canonical} />}
      {post.featuredImage && <meta property="og:image" content={post.featuredImage} />}
    </Helmet>
    <h1>{post.title}</h1>
    {post.publishedAt && <p className="text-muted-foreground">{new Date(post.publishedAt).toLocaleDateString()}</p>}
    {(post.author || post.category) && <p className="text-muted-foreground">{post.author}{post.author && post.category ? ' · ' : ''}{post.category}</p>}
    <div dangerouslySetInnerHTML={{ __html: post.content }} />
  </article>
}